if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"amd_legacy","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(010|26|433|806|939)|2(320|585|700|732|848)|3(6(56|92|93)|210|376|779)|4(183|628|853)|5(708|818|95|960)|6(5(36|62|81)|19|774|929)|7(71[59]|124)|8(004|360|43|696|756)|9(32|390|802))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}